import * as React from 'react';
import type { SVGProps } from 'react';
const SvgButtonTagError = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#E4002B" fillRule="evenodd" d="M16 15H0v-3L7 0h2l7 12zM7 4h2v5H7zm0 7h2v2H7z" clipRule="evenodd" />
  </svg>
);
export default SvgButtonTagError;
